import {
  Gear,
  GitPullRequest,
  House,
  Robot,
  ShieldChevron,
  ShieldWarning,
} from '@phosphor-icons/react';
import type { Icon } from '@phosphor-icons/react';

export interface CloudDashboardNavItem {
  icon: Icon;
  label: string;
  dataTour?: string;
}

export const CLOUD_DASHBOARD_NAV_MAIN: CloudDashboardNavItem[] = [
  { icon: House, label: 'Dashboard' },
  { icon: GitPullRequest, label: 'Pull Requests', dataTour: 'nav-pull-requests' },
  { icon: ShieldWarning, label: 'Backlog', dataTour: 'nav-findings' },
  { icon: ShieldChevron, label: 'Governance' },
];

export const CLOUD_DASHBOARD_NAV_TOOLS: CloudDashboardNavItem[] = [
  { icon: Robot, label: 'Developer Setup' },
  { icon: Gear, label: 'Settings' },
];
